import { IApplicationState } from '../../types/redux';

export function selectVacancies(state: IApplicationState) {
  return state.vacancies;
}

export function selectVacanciesGroup(state: IApplicationState) {
  return state.vacancies.vacanciesGroup;
}

export function selectVacancy(state: IApplicationState) {
  return state.vacancies.vacancy;
}
